import React from "react";

const MASTER_DETAIL_GRID_SECTION_IDS = new Set([
    "sozai_haisyoku",
    "fuzoku_haisyoku"
]);

function renderEmptyBody() {
    return (
        <div style={{ minHeight: 120, border: "1px solid #d0d0d0", borderRadius: 4, backgroundColor: "#fafafa" }}>
        </div>
    );
}

export function isMasterDetailGridSection(section) {
    const sectionId = String(section?.id ?? "").trim();
    return MASTER_DETAIL_GRID_SECTION_IDS.has(sectionId);
}

export function renderMasterDetailGridSectionBody({
    section,
    gridSectionPanel,
    stableGridPanel,
    hasGridColumns,
    renderContents,
    colorwayDetailParams,
    toStableAutoHeightPanel
}) {
    if (!hasGridColumns) {
        return renderEmptyBody();
    }

    const renderGridPanel = stableGridPanel || toStableAutoHeightPanel(gridSectionPanel, section.id);
    return renderContents({
        panel: renderGridPanel,
        masterDetail: true,
        detailCellRendererParams: colorwayDetailParams(section.id)
    });
}
